var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4253_9086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1775 1.92153C2.1775 2.51205 1.69855 2.99099 1.10804 2.99099C0.517518 2.99099 0.0385742 2.51205 0.0385742 1.92153C0.0385742 1.33051 0.517518 0.851562 1.10804 0.851562C1.69855 0.851562 2.1775 1.33051 2.1775 1.92153Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1775 5.99524C2.1775 6.58576 1.69855 7.0647 1.10804 7.0647C0.517518 7.0647 0.0385742 6.58576 0.0385742 5.99524C0.0385742 5.40472 0.517518 4.92578 1.10804 4.92578C1.69855 4.92578 2.1775 5.40472 2.1775 5.99524Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1775 10.0695C2.1775 10.6605 1.69855 11.1394 1.10804 11.1394C0.517518 11.1394 0.0385742 10.6605 0.0385742 10.0695C0.0385742 9.47894 0.517518 9 1.10804 9C1.69855 9 2.1775 9.47894 2.1775 10.0695Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55309 2.17747C3.41247 2.17747 3.29834 2.06334 3.29834 1.92272C3.29834 1.7821 3.41247 1.66797 3.55309 1.66797H11.7027C11.8433 1.66797 11.9574 1.7821 11.9574 1.92272C11.9574 2.06334 11.8433 2.17747 11.7027 2.17747H3.55309Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55309 6.25169C3.41247 6.25169 3.29834 6.13756 3.29834 5.99694C3.29834 5.85632 3.41247 5.74219 3.55309 5.74219H11.7027C11.8433 5.74219 11.9574 5.85632 11.9574 5.99694C11.9574 6.13756 11.8433 6.25169 11.7027 6.25169H3.55309Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55309 10.3259C3.41247 10.3259 3.29834 10.2118 3.29834 10.0712C3.29834 9.93054 3.41247 9.81641 3.55309 9.81641H11.7027C11.8433 9.81641 11.9574 9.93054 11.9574 10.0712C11.9574 10.2118 11.8433 10.3259 11.7027 10.3259H3.55309Z",
    fill: "#A0AEC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4253_9086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10.4348,
    fill: "white",
    transform: "translate(0 0.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaTab);
export default __webpack_public_path__ + "static/media/ca_tab.5a553bc7da876909e7cd5d3d75e26149.svg";
export { ForwardRef as ReactComponent };